'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};



// WEBPACK FOOTER //
// ./packages/array-xy-max-y/node_modules/number-is-nan/index.js